import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Comunicacao = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Sinal";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.comunicacao})` }}>
        <div className="servico-hero-overlay">
          <h1>Sinal</h1>
          {/*<p>Para quem procura por diversidades em comunicação</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Comunicação e Eletrônicos */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.audioSom} alt="" /></div>
            <h3>Áudio</h3>
            <p>Rádios, caixas de som e microfones.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.telefoniaComunicacao} alt="" /></div>
            <h3>Telefonia</h3>
            <p>Aparelhos com fio e sem fio.</p>
          </div>


          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.controleRemotos} alt="" /></div>
            <h3>Controles</h3>
            <p>Modelos universais, de diversas marcas e para ar-condicionado.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.controleAntenasTV} alt="" /></div>
            <h3>Antenas</h3>
            <p>Modelos digitais e com HDTV.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.cabosAdaptadores} alt="" /></div>
            <h3>Conexão</h3>
            <p>Cabos e adaptadores para transmissão de sinal.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('sinais')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('sinais')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Comunicacao;